// What each template variable starts as for a new staff member in a space:
// the space's default for that key (Settings › Default answers), else the
// engagement name. One rule for Add staff, Paste a list and — server-side, in
// services/spaces.variable_prefill — the principal's own interview link.
// The space as the principal's page shows it: the variables she isn't asked
// for (Settings' "Show to principal" unticked) left off the list and off her
// rows. Her own GET already comes this way; this is for an admin opening her
// view, whose GET carries everything.
export function principalView(space) {
  const hidden = new Set(space?.hidden_variables ?? [])
  if (hidden.size === 0) return space
  const strip = (variables) =>
    Object.fromEntries(Object.entries(variables ?? {}).filter(([key]) => !hidden.has(key)))
  return {
    ...space,
    template_variables: (space.template_variables ?? []).filter((v) => !hidden.has(v.key)),
    staff: (space.staff ?? []).map((row) => ({ ...row, variables: strip(row.variables) })),
  }
}

export function variablePrefill(space) {
  const defaults = space?.variable_defaults ?? {}
  return Object.fromEntries(
    (space?.template_variables ?? []).map((variable) => [
      variable.key,
      (defaults[variable.key] ?? '').trim() || space.engagement || '',
    ]),
  )
}
